parasails.registerPage('interact', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    overallEventID: '',
    deviceidentifier: '',
    eventType: '',
    partType: '',
    eventData: {},
    eventIsLive: false,
    partIsLive: false,
    pleaseWait: false,
    partIndex: 0,
    questionIndex: 0,
    syncing: false,
    formData: { /* … */ },
    formErrors: { /* … */ },
    formRules: {
      fullName: { required: false },
      message: { required: true },
    },
    cloudError: '',
    cloudSuccess: false,
    currentPartData: {},
    currentVoteData: {},
    currentPartIndex: 0,
    shouldShowConfirm: true,
    shouldShowMessageSent: true,
    showVoteConfirmation: false,
    selectedVoteText: '',
    confirmSendModal: false,
    messageSentModal: false,
    chirpAgainTimeoutID: undefined,
    freeSwitch: false,
    additionalstyle: '',
    backgroundStyle: 'background-image: url("../images/chirp/chirp-bg.webp");',
    eventLogo: 'images/chirp/chirp-logo.webp',
    showNameInput: false,
    newlineCharacter: "%0A",
    hashtagCharacter: "%23",
    hashtags: "",
    selectedVoteIndex: -1,
    showHeader: true,
    showFooter: true,
    isRefreshingData: false,
    idleTexts: {
      waiting: "Event Ended",
      noActiveVote: "Event Ended",
      partNotLive: "Event Ended",
      eventNotLive: "Event Ended",
      waitingColor: "#000000",
      noActiveVoteColor: "#000000",
      partNotLiveColor: "#000000",
      eventNotLiveColor: "#000000"
    },
    keyhackval: 0,
    maxCharacters: 100,
    characterCount: 0,
    exceededLimit: false,
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function () {
    //…
  },
  mounted: async function () {
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.currentPartIndex = 0;

    if (this.eventData) {
      this.eventID = this.eventData.id;
      this.eventIsLive = this.eventData.isLive;
      this.deviceidentifier = this.eventData.deviceidentifier;
    } else {
      window.location.href = '/404';
      return;
    }

    console.log("event is live = ", this.eventIsLive);

    if (this.eventData.parts.length > 0) {
      if (this.eventData.focusPartID != null) {
        //This event has a focus part, so we need to find it and set the partIndex to that...
        for (var fpi = 0; fpi < this.eventData.parts.length; fpi++) {
          if (this.eventData.parts[fpi].id === this.eventData.focusPartID) {
            this.partIndex = fpi;
            break;
          }
        }
      } else {
        for (var pi = 0; pi < this.eventData.parts.length; pi++) {
          if (this.eventData.parts[pi].isLive) {
            this.partIndex = pi;
            break;
          }
        }
      }
    }

    if (!this.partIndex) { this.partIndex = 0; }

    this.currentPartData = this.eventData.parts[this.partIndex];
    this.partIsLive = this.currentPartData.isLive;
    this.formData.eventid = this.eventData.id;
    this.formData.partid = this.partIndex;

    if (this.currentPartData.hasOwnProperty('eventPartOptions')) {
      this.shouldShowConfirm = (this.currentPartData.eventPartOptions.hasOwnProperty('shouldShowConfirm')) ? this.currentPartData.eventPartOptions.shouldShowConfirm : true;
      this.shouldShowMessageSent = (this.currentPartData.eventPartOptions.hasOwnProperty('shouldShowMessageSent')) ? this.currentPartData.eventPartOptions.shouldShowMessageSent : true;
    }

    this.partType = this.currentPartData.partType.toLowerCase();
    switch (this.partType) {
      case 'chirp':
      case 'tweet':
          this.showHeader = true;
          break;
      case 'vote':
      case 'qa':
        console.log("Checking for live questions/votes in part...");
        if (this.currentPartData.questions.length > 0) {
          console.log("CHECKING FOR LIVE QUESTIONS");
          var foundLive = false;
          this.currentPartData.questions.forEach(q => {
            // console.log("checking part question/vote: ", JSON.stringify(q));
            if(q.isLive == true) {
              console.log("Found live question/vote in part.");
              foundLive = true;
            }
          })
          if(foundLive == true) {
            console.log("Found live question/vote in part, setting current vote...");
            this.setCurrentVote(this.partIndex, this.questionIndex);
          } else
            this.showHeader = true;
        } else {
          console.log('No Question/Vote data found in part.');
        }
        break;
      default:
        this.partType = this.eventType;
        this.partIsLive = false;
        this.pleaseWait = true;
        this.showHeader = true;
    }

    io.socket.on(this.eventData.id, (params) => {
      switch (params.eventType) {
        case 'startevent':
          console.log("EVENT STARTED!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.partIsLive = false;
          this.eventIsLive = true;
          this.showHeader = true;
          break;
        case 'endevent':
          console.log("EVENT ENDED!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.partIsLive = false;
          this.eventIsLive = false;
          this.showHeader = true;
          break;
        // case 'chirp':
        //   console.log("Received CHRIP event...");
        //   this.showVoteConfirmation = false;
        //   this.messageSentModal = false;
        //   this.partIsLive = true;
        //   this.pleaseWait = true;
        //   this.showHeader = true;
        //   this.partType = this.currentPartData.partType.toLowerCase();
        //   break;
        case 'startvote':
        case 'rotatevote':
          console.log("STARTING VOTE!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.showHeader = false;
          this.partIsLive = true;
          this.pleaseWait = false;
          this.partType = this.currentPartData.partType.toLowerCase();
          this.setCurrentVote(params.partindex, params.voteid, true);
          // this.currentVoteData.isLive = true;
          break;
        case 'startpart':
          console.log("STARTING PART!");
          this.showHeader = true;
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.partIndex = params.partindex;
          this.currentPartData = this.eventData.parts[this.partIndex];
          this.partType = this.currentPartData.partType.toLowerCase();
          if(!this.questionIndex) {this.questionIndex = this.partIndex;}
          this.currentVoteData.partindex = this.questionIndex;
          if(this.partType === 'tweet' || this.partType === 'chirp') {
            this.partIsLive = true;
            this.showHeader = true;
          } else if(this.partType === 'vote' || this.partType === 'qa' || this.partType === 'quiz') {
            this.partIsLive = true;
            this.pleaseWait = true;
            this.showHeader = true;
          } else if(this.partType === 'wait') {
            this.partIsLive = true;
            this.pleaseWait = true;
          } else {
            this.partIsLive = true;
            this.pleaseWait = true;
          }
          this.currentPartData.isLive = this.partIsLive;
          break;
        case 'endpart':
          console.log("ENDING PART!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.pleaseWait = true;
          this.partIsLive = false;
          this.showHeader = true;
          break;
        case "endquestion":
          console.log("ENDING QUESTION/VOTE!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.showHeader = true;
          this.endQuestion(params.partindex, params.voteid);
          break;
        case 'endvote':
          console.log("ENDING VOTE!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.partIsLive = false;
          this.showHeader = true;
          break;
        case 'showresults':
        case 'pleasewait':
          console.log("SHOWING RESULTS / PLEASE WAIT!");
          this.showVoteConfirmation = false;
          this.messageSentModal = false;
          this.showResults = true;
          break;
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    confirmSubmit: async function () {
      if (this.shouldShowConfirm) {
        //this.confirmSendModal = true;
        var containsNGWords = false;
        if(this.formData.message && this.formData.message.length && this.formData.message.length > 0){
          containsNGWords = await Cloud.checkNg.with({
            originalText: this.formData.message
          });
        }

        var detectedLanguage = await Cloud.detectLanguage.with({
          text: this.formData.message
        });

        if (containsNGWords.includesNG === false && (detectedLanguage === "en" || detectedLanguage === "ja")) {
          if (this.shouldShowConfirm) {
            this.confirmSendModal = true;
            this.cloudError = '';
          }
        } else {
          this.cloudError = 'Language Failure';
        }
      }
    },
    submittedForm: async function () {
      // Show the success message.
      this.cloudSuccess = true;
      this.confirmSendModal = false;
      if (this.shouldShowMessageSent == true) {
        console.log("should show message sent...")
        this.messageSentModal = true;
      }
      this.partIsLive = true;
      this.chirpAgainTimeoutID = setTimeout(this.chirpagain, 5000);
    },
    chirpagain() {
      this.messageSentModal = false;
      clearTimeout(this.chirpAgainTimeoutID);
      this.formData = {}; // Clear the form data object
      this.formErrors = {}; // Clear the form errors object
      this.cloudSuccess = false;
      this.confirmSendModal = false;
      this.syncing = false;
      this.cloudError = '';
      this.formData.eventid = this.eventData.id;
      this.formData.partid = this.currentPartIndex;
      this.partIsLive = true;
    },
    async setCurrentVote(partIndex, voteIndex, fromSocket = false) {
      console.log("SHOWING VOTE!")
      this.showHeader = false;
      this.partIndex = partIndex;
      this.questionIndex = voteIndex;
      this.showVoteConfirmation = false;
      this.currentPartData = this.eventData.parts[this.partIndex];
      this.partType = this.currentPartData.partType.toLowerCase();
      console.log("DID THE FIRST BIT");
      
      for(var p in this.eventData.parts) {
        p.isLive = false;
      }
      
      this.currentPartData.isLive = true;
      this.partIsLive = true;
      if(this.isRefreshingData === false) await this._fetchNewQuestionData();
      if(fromSocket === false) {
        for(var timmy = 0; timmy < this.eventData.parts[partIndex].questions.length; timmy++)
        {
          if(this.eventData.parts[partIndex].questions[timmy].isLive === true)
          {
            this.questionIndex = timmy;
            break;
          }
        }
      }

      this.currentVoteData = this.currentPartData.questions[this.questionIndex];
      if(this.currentVoteData === null || this.currentVoteData === undefined) {
        window.location.reload();
        return;
      }
      this.currentVoteData.voted = false;
      this.currentVoteData.isLive = true;
      this.currentVoteData.votedIndex = -1;
      this.selectedVoteIndex = -1;
      this.currentVoteData.partindex = partIndex;

      // this.$set(this.currentVoteData, 'questionBgColor', this.currentVoteData.bgcolor); // For the fill color
      // this.$set(this.currentVoteData, 'questionFrameColor', this.currentVoteData.color); // For the frame color
      console.log("CURRENT VOTE DATA LIVE STATUS: ", this.currentVoteData.isLive);
      console.log("PART IS LIVE: ", this.partIsLive);
      this.keyhackval = Math.floor(Math.random() * 100) + 1;
    },
    _fetchNewQuestionData: async function() {
      this.isRefreshingData = true;
      try {
        const response = await fetch(`getquizdataforpart?partid=${this.currentPartData.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if(data !== null && data.length > 0) {
          this.eventData.parts[this.partIndex].questions = data;
          this.currentPartData.questions = data;
        }
        this.isRefreshingData = false;
      } catch (error) {
        console.error('Error fetching new question data:', error);
        this.isRefreshingData = false;
      }
    },
    voteSelected: function(index) {
      this.currentVoteData.votedIndex = index;
      this.selectedVoteIndex = index;
      this.selectedVoteText = this.currentVoteData.votes[index].text;
    },
    voted: function() {
      this.currentVoteData.voted = true;
      this.showVoteConfirmation = true;
    },
    endQuestion(partIndex, voteIndex)
    {
      this.eventData.parts[partIndex].questions[voteIndex].isLive == false;
      this.currentVoteData.isLive = false;
    },
  }
});
